import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { effect, Injectable, inject, PLATFORM_ID } from '@angular/core';
import { ConsentService } from '../consent/consent.service';
import { UserIdentifierService } from './user-identifier.service';

const ONE_YEAR_SECONDS = 31_536_000;

/**
 * Mirrors the visitor's altuid into a first-party cookie while analytics is allowed, so the
 * go edge function can attribute a click without reading localStorage. Clears it otherwise.
 */
@Injectable({ providedIn: 'root' })
export class AltuidCookieService {
  private readonly document = inject(DOCUMENT);
  private readonly consent = inject(ConsentService);
  private readonly userIdentifier = inject(UserIdentifierService);

  constructor() {
    if (!isPlatformBrowser(inject(PLATFORM_ID))) return;
    effect(() => {
      if (this.consent.analyticsAllowed()) {
        const id = this.userIdentifier.fetchAndStoreUserIdentifierSync();
        if (id) this.write(encodeURIComponent(id), ONE_YEAR_SECONDS);
      } else {
        this.write('', 0);
      }
    });
  }

  private write(value: string, maxAge: number): void {
    this.document.cookie = `altuid=${value}; Path=/; SameSite=Lax; Secure; Max-Age=${maxAge}`;
  }
}
